export const loginUrl = '/capi/customer/initialize';

export const logoutUrl = '/capi/customer/logout';

export const registerUrl = '/capi/customer/initialize';

export const profileUrl = '/capi/customer/profile';
